import { Badge, Center, DataList } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const CryptoCallback = () => {
  const location = useLocation();
  const [data, setData] = useState([]);
  useEffect(() => {
    let status;

    if (location.pathname.includes("crypto-success")) {
      status = "Success";
    } else if (location.pathname.includes("crypto-failed")) {
      status = "Failed";
    }
    setData([
      {
        label: "Status",
        value: (
          <Badge colorPalette={status === "Success" ? "green" : "red"}>
            {status}
          </Badge>
        ),
      },
    ]);
    const timer = setTimeout(() => {
      window.close();
    }, 5000);
  
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <Center>
      <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
        {data.map((item) => (
          <DataList.Item key={item.label} pt="4">
            <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
            <DataList.ItemValue>{item.value}</DataList.ItemValue>
          </DataList.Item>
        ))}
      </DataList.Root>
    </Center>
  );
};
